import styled from 'styled-components';

const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;

  > * {
    &:not(:last-child) {
      margin-right: 24px;
    }
  }
`;

CheckboxGroup.displayName = 'CheckboxGroup';

export default CheckboxGroup;
